import { useQuery } from "react-query";
import { Role } from "../models/users/role.model";
import { rolesService } from "../../services/roles.service";

export function useRolesQuery() {
  return useQuery<Role[]>(["roles"], () => rolesService.getAllRoles());
}
